import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRequestHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#26C6DA' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M18.913 24.253A7.5 7.5 0 0 0 24.5 17c0-4.14-3.33-7.5-7.5-7.5-5.002 0-7.5 4.17-7.5 4.17m0 0v-3.42m0 3.42h3.33'
    />
    <path
      stroke='#fff'
      strokeDasharray='3 3'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M9.5 17c0 4.14 3.36 7.5 7.5 7.5'
    />
  </svg>
);
export default SvgRequestHistory;
